import SiteLayout from '@/components/feature/SiteLayout';
import { usePageMeta } from '@/hooks/usePageMeta';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import HomeNews from '@/pages/home/components/HomeNews';
import HomeWorks from '@/pages/home/components/HomeWorks';
import HomeCulture from '@/pages/home/components/HomeCulture';
import HomeAbout from '@/pages/home/components/HomeAbout';

export default function Home() {
  usePageMeta({
    title: '琉璃神社-动漫资讯与文化分享平台',
    description:
      '琉璃神社为动漫爱好者提供丰富的动漫资讯、作品介绍及文化内容，涵盖动画、漫画及周边动态，是动漫交流与分享的理想平台。',
    keywords: '琉璃神社,动漫资讯,动漫文化,动画推荐,漫画作品,二次元,动漫交流,文化分享',
  });

  return (
    <SiteLayout>
      <HeroCarousel />
      <CategoryEntries />
      <HomeNews />
      <HomeWorks />
      <HomeCulture />
      <HomeAbout />
    </SiteLayout>
  );
}